export default "__VITE_ASSET__nBqcxynn__"